import { SCHEDULE_STRINGS } from '../_constants/scheduleStrings'
import S from './PendingStudentLabel.style'

/** 오른쪽 학생 목록에서 "이미 출제됨" 자리에 들어가는 예약 학생 표시 */
const PendingStudentLabel = () => (
  <span css={S.label}>{SCHEDULE_STRINGS.pendingStudentLabel()}</span>
)

export default PendingStudentLabel
